"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTfrcStrategy = createTfrcStrategy;
const constants_1 = require("../constants");
const validationHelpers_1 = require("../common/validationHelpers");
/** Full PRO length: 8-digit base + 1 check digit (TForce / TFRC tenant) */
const TFRC_PRO_NUMBER_LENGTH = 9;
const TFRC_BASE_LENGTH = 8;
function createTfrcStrategy(options) {
    var _a, _b;
    const { enableCheckDigit, proNumberLengthConstraints } = options;
    const minLength = (_a = proNumberLengthConstraints === null || proNumberLengthConstraints === void 0 ? void 0 : proNumberLengthConstraints.minLength) !== null && _a !== void 0 ? _a : TFRC_PRO_NUMBER_LENGTH;
    const maxLength = (_b = proNumberLengthConstraints === null || proNumberLengthConstraints === void 0 ? void 0 : proNumberLengthConstraints.maxLength) !== null && _b !== void 0 ? _b : TFRC_PRO_NUMBER_LENGTH;
    const getCheckDigit = (baseEightDigits) => {
        if (baseEightDigits.length !== TFRC_BASE_LENGTH) {
            return 0;
        }
        if (isNaN(Number(baseEightDigits))) {
            return 0;
        }
        return Number(baseEightDigits) % 7;
    };
    const getProNumberWithCheckDigit = ({ proNumber, }) => {
        if (enableCheckDigit && proNumber.length === TFRC_BASE_LENGTH) {
            return proNumber + getCheckDigit(proNumber).toString();
        }
        return proNumber;
    };
    const validateProNumber = (validationInput) => {
        const { proNumber } = validationInput;
        const proNumberLen = proNumber.length;
        if (proNumberLen < minLength) {
            return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.PRO_NUMBER_MIN, {
                minLength,
            });
        }
        if (proNumberLen > maxLength) {
            return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.PRO_NUMBER_MAX, {
                maxLength,
            });
        }
        if (enableCheckDigit && proNumberLen === TFRC_PRO_NUMBER_LENGTH) {
            const enteredCheckDigit = Number(proNumber.slice(-1));
            const baseEight = proNumber.slice(0, TFRC_BASE_LENGTH);
            const calculatedCheckDigit = getCheckDigit(baseEight);
            if (enteredCheckDigit !== calculatedCheckDigit) {
                return (0, validationHelpers_1.createValidationError)(constants_1.PRO_VALIDATION_ERROR_TYPES.INVALID_CHECK_DIGIT);
            }
        }
        return null;
    };
    const isTempProNumber = (_proNumber) => {
        return false;
    };
    return {
        getProNumberWithCheckDigit,
        validateProNumber,
        isTempProNumber,
    };
}
